var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 6V18M9.75 3.75L12 6 14.25 3.75M9.75 20.25L12 18 14.25 20.25M6.80371 9L17.196 15M3.73022 9.82346L6.80372 8.99986 5.98022 5.92627M18.0198 18.0735L17.1963 14.9999 20.2698 14.1763M6.80371 15L17.196 9M5.98022 18.0735L6.80372 14.9999 3.73022 14.1763M20.2698 9.82346L17.1963 8.99986 18.0198 5.92627", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});